import { Injectable } from '@angular/core';
import { UserKeyclaokPermission } from './papel';
import Keycloak from 'keycloak-js';


const GROUP_OPERADORA_ROOT = 'OPERADORA';
const GROUP_PAPEL_ROOT = 'PAPEL';


/**
 * Gerencia todos os serviços referente ao contexto de autenticação do usuário.
 */
@Injectable({
  providedIn: 'root',
})
export class AuthService {
  constructor(private keycloak: Keycloak) {}

  /**
   * Efetua o logout da aplicação e redireciona para o keyclack.
   */
  logout(redirectUri?: string): void {
    this.keycloak.logout({ redirectUri });
  }

  /**
   * Retorna os Grupos associados ao token do usuário.
   */
  getUserGrupos() {
    const token = this.keycloak.tokenParsed;
    const grupos = token?.Grupos as string[];
    return grupos ?? [];
  }

  /**
   * Retorna as operadoras e os papéis dos grupos do token. O acesso é decidido pelo perfil
   * (`GET geral/perfil`); isto só alimenta a conferência de `divergenciasPerfilToken`.
   */
  getUserPermissoes(): UserKeyclaokPermission {
    const grupos = this.getUserGrupos().map(grupo => grupo.split('/'));
    const doGrupo = (raiz: string) =>
      grupos.filter(partes => partes[1]?.toUpperCase() === raiz && partes.length > 2).map(partes => partes[2]);

    return {
      operadoras: doGrupo(GROUP_OPERADORA_ROOT),
      papeis: doGrupo(GROUP_PAPEL_ROOT).map(papel => papel.toUpperCase()),
    };
  }

}
